export const ASPECTRATIO_1X1 = "ratio-1x1";
export const ASPECTRATIO_16X9 = "ratio-16x9";
export const ASPECTRATIO_2X1 = "ratio-2x1";
export const ASPECTRATIO_3X4 = "ratio-3x4";
export const ASPECTRATIO_4X3 = "ratio-4x3";

export const ASPECT_RATIOS = [
  ASPECTRATIO_1X1,
  ASPECTRATIO_16X9,
  ASPECTRATIO_2X1,
  ASPECTRATIO_3X4,
  ASPECTRATIO_4X3
] as const;
